
// src/web/components/diary-comment-form.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/diary-comment-form'
import { themr } from 'react-css-themr'
import classnames from 'classnames'
import diaryTheme from './themes/diary.css'
import {
  IconButton,
  Button,
} from 'react-toolbox/lib/button'
import {
  Card,
  CardText,
  CardActions,
} from 'react-toolbox/lib/card'
import Chip from 'react-toolbox/lib/chip'
import Checkbox from 'react-toolbox/lib/checkbox'
import Avatar from 'react-toolbox/lib/avatar'
import RichTextEditor from './rich-text-editor.jsx'
import DiaryUploadFiles from './diary-upload-files.jsx'
import FileUploadButton from './file-upload-button.jsx'
import successButtonTheme from './themes/success-button.css'
import { deleteArray, mergeArray } from '../../helpers/store'
import _ from 'lodash'

@themr('Diary', diaryTheme)
class DiaryCommentForm extends React.Component {
  showUserSelectionDialog = ()=> this.props.showUserSelectionDialog(
    this.props.t('label:読んでみての宛先を追加'),
    true,
    // すべての投稿から開いた時にはgroup.membersは存在しないため、MENTION_TO_USERSを渡す。github pull/5755#issuecomment-1264972956
    this.props.group && this.props.group.members ? 'GROUP_MEMBERS_MENTION' : 'MENTION_TO_USERS',
    this.props.group && this.props.group,
    this.props.ui.mentions,
    (users)=> this.props.updateUI({
      mentions: mergeArray('user_id', [], users),
    })
  )
  onEditorInitialized = (handlers)=> this.props.updateUI({ handlers })
  submitComment = ()=> this.props.submitComment(this.props)
  toggleReplyRequested = ()=> this.props.updateUI({ reply_requested: !this.props.ui.reply_requested })

  render() {
    const {
      t,
      ui,
      theme,
      diary,
      group,
      user,
      isPosting,
      isPostFailed,
      isUploading,
      onClose,
      submitComment,
      uploadFiles,
      uploadedFiles,
      uploadedVideos,
      updateUI,
      componentId,
      showUserSelectionDialog,
      parent,
    } = this.props

    const isChild = parent.diary_id ? false : true

    return (
      <CardText theme={theme} className={isChild ? "replyCommentForm" : "diaryCommentForm"}>
        <Avatar theme={theme} className="avatar" image={user.icon_image.thumb_url} />
        <Card theme={theme} className={isChild ? "replyCommentForm" : "diaryCommentForm"}>
            <div style={{ padding: '5px' }}>
              <Button theme={successButtonTheme}
                  raised={!(ui.mentions && ui.mentions.length > 0)}
                  floating={(ui.mentions && ui.mentions.length > 0)}
                  mini={(ui.mentions && ui.mentions.length > 0)}
                  onClick={this.showUserSelectionDialog}
                  icon="person_add"
                  label={!(ui.mentions && ui.mentions.length > 0) && t('label:読んでみての宛先を追加')}
                  style={{ verticalAlign: 'top', marginRight: '10px' }} />
              {ui.mentions && _.map(ui.mentions.slice(0, 10), (mention, i) => <Avatar image={mention.icon_image.thumb_url} style={{ marginLeft: 2 }}/>)}
              {ui.mentions && ui.mentions.length > 10 &&  <Button
                primary
                onClick={this.showUserSelectionDialog}
                icon='arrow_forward'
                label={t('label:他n人', { n: ui.mentions.length　-　10 }) + 'を' + t('label:すべて表示')} />}
              {ui.mentions && ui.mentions.length > 0 &&
                <div style={{ marginTop: '10px', marginLeft: '10px' }} >
                  <Checkbox checked={ui.reply_requested} label={t('label:返信を要求')} onChange={this.toggleReplyRequested} />
                </div>
              }
            </div>

          <RichTextEditor compact hasFocus
              onDrop={uploadFiles}
              onEditorInitialized={this.onEditorInitialized}
              placeholder={t('label:コメントを入力してください')} />

          <DiaryUploadFiles componentId={componentId} />

          <CardActions theme={theme}>
            <Button raised primary
                disabled={isPosting || isUploading}
                icon='send'
                onClick={this.submitComment}
                label={t('label:返信')} />
            <FileUploadButton raised
                icon='add_a_photo'
                onChange={uploadFiles}
                label={t('label:添付')} />
            <Button 
                style={{ marginLeft: 'auto' }}
                icon="close"
                onClick={onClose}
                label={t('label:取り消し')} />
          </CardActions>
        </Card>
      </CardText>
    )
  }
}

export const RawDiaryCommentForm = DiaryCommentForm
export default connect(DiaryCommentForm)



// WEBPACK FOOTER //
// ./src/web/components/diary-comment-form.jsx